import React from "react";
import CashBook from "./CashBook";

export default function BankBook() {
  return <CashBook variant="bank" />;
}
